module.exports = __webpack_public_path__ + "media/images/pic/blog/justyna-kotlarczyk-e8cf94231199fa661e7d50683cc72c5d.jpeg";